import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
//订单状态枚举
interface State {
  orderStatusList: {
    value: string;
    label: string;
  }[];
  orderStatusMenu: {
    [key: string]: string;
  };
  active: string;
  setActive: (active: string) => void;
}

export const useOrderStatusStore = create(
  devtools(
    persist<State>(
      (set) => ({
        orderStatusList: [
          { value: '999', label: '全部' },
        
          { value: '0', label: '待付款' },
          { value: '10', label: '待发货' },
          { value: '20', label: '已发货' },
          { value: '30', label: '已收货' },
          { value: '40', label: '已完成' },
        
          { value: '-10', label: '退货申请' },
          { value: '-20', label: '退款中' },
          { value: '-30', label: '已退货' },
          { value: '-40', label: '已关闭' },
        ],
        orderStatusMenu:{
          '999': '全部',
          '0': '待付款',
          '10': '待发货',
          '20': '已发货',
          '30': '已收货',
          '40': '已完成',
        
          '-10': '退货申请',
          '-20': '退款中',
          '-30': '已退货',
          '-40': '已关闭',
        },
        active: '999',
        setActive: (active: string) => set((state) => ({ active: active })),
      }),
      {
        name: "order-status-storage",
      }
    ),
    {
      name: "orderStatusStore",
    }
  )
);